import Sidebar from "../../components/sidebar/Sidebar";
import MainHeader from "./Header/MainHeader";
import Footer from "./Footer/Footer";
import AutoScroll from "../../providers/AutoScroll";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {fetchPublicKey} from "../../redux/Reducers/StripePublicKeySlice";
import {useSession} from "../../redux/Reducers/AuthReducer";
import getStripePromise from "../../API/ApiEndPoints/loadStripe";


export default function MainLayout({className, ...props}) {
    const {session,authActions} = useSession();
    useEffect(() => {
        authActions.refreshPackage();

    }, [])
    return (
        <AutoScroll>
            <div id={"main-layout"}
                 className={`no-selection w-[100vw] h-[100vh] flex flex-row bg-gray-50 dark:bg-darkTheme-900  ${className}`}>
                <Sidebar/>
                <div className={"flex h-full flex-col flex-1"}>
                    <MainHeader/>
                    <main className="h-full flex flex-col  overflow-y-auto">
                        <div id={"main-container"} className="max-w-[100vw] w-full flex-1">{props.children}</div>


                        <Footer/>
                    </main>

                </div>
            </div>
        </AutoScroll>

    )
}